<template>
  <v-container style="height: 355px; max-height: 500px; overflow: auto;">
    <v-row justify="end" align="center">
      <v-checkbox
        :label="$t('OnlyUsedElements')"
        :disabled="disabledView"
        color="accent"
        v-model="usedElements"
      />
      <v-col cols="8" sm="4" style="z-index: 3" v-on-clickaway="closeSearch">
        <v-text-field
          rounded
          @click="menu = !menu"
          dense
          class="menu"
          height="32"
          solo
          :placeholder="$tc('AddActivity')"
          v-model="searchTemplate"
          :disabled="disabledView"
          append-icon="arrow_drop_down"
        />
        <div class="menu-position-templates" v-if="menu">
          <ul v-if="filterTemplates.length > 0">
            <li
              v-for="templates of filterTemplates"
              :key="templates.uuid"
              @click="selectTemplate(templates)"
            >
              {{ templates.title }}
            </li>
          </ul>
          <ul v-else>
            <li>No Data Available</li>
          </ul>
        </div>
      </v-col>
    </v-row>
    <div class="d-flex mt-9 pl-0">
      <div class=" d-flex justify-center flex-column">
        <v-col
          v-for="(template, i) of selectedTemplatesFor"
          :key="i"
          class="d-flex justify-start mb-5 pl-0"
        >
          <div
            v-if="
              receivedData.activities.find(
                item => item.title === template.title
              )
            "
            class=" d-flex align-start justify-start pr-2 "
            style="width: 36px"
          >
            <div>
              <v-btn
                class="rotate-button"
                tile
                icon
                small
                @click="deleteTemplate(template)"
              >
                <v-icon small>delete</v-icon>
              </v-btn>
              <span class="rotate-text">
                {{ template.title }}
              </span>
            </div>
          </div>
          <div class=" left-side d-flex flex-column">
            <div
              v-for="activity of receivedData.activities"
              :key="activity.uuid"
            >
              <v-card
                v-if="activity.title === template.title"
                min-width="585px"
                width="585px"
                height="80px"
                class="d-flex align-center "
                style="margin-bottom: 40px; margin-left:20px;"
                elevation="0"
              >
                <v-sheet class="card-title" width="220" height="30" rounded>
                  <div class="text-truncate">
                    <span v-if="activity.object && activity.object.label " :title="activity.object.label">
                      {{ activity.object.label }}</span
                    >
                    <span v-else :title="activity.object_uuid">
                      {{ getObjectTypeLabel(activity.object_type) }} UUID -
                      {{ activity.object_uuid }}</span
                    >
                  </div>
                </v-sheet>
                <v-btn
                  v-if="!disabledView && checkActivityOrTaskState(activity.state)"
                  icon
                  size="20"
                  class="activity-delete-button"
                  @click="openActivityDialog(activity)"
                  :disabled="disabledView"
                >
                  <v-icon small>delete</v-icon>
                </v-btn>

                <v-sheet
                  v-for="task of activity.tasks"
                  :key="task.uuid"
                  color="#E1E1E1"
                  elevation="0"
                  height="50"
                  rounded
                  width="130"
                  class="ml-2 d-flex align-start justify-space-between"
                >
                  <span class="task-text text-truncate" :title="task.title">
                    {{ task.title }}
                  </span>
                  <v-btn
                    v-if="!disabledView && checkActivityOrTaskState(task.state)"
                    icon
                    size="20"
                    @click="openTaskDialog(activity, task)"
                    :disabled="disabledView"
                  >
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </v-sheet>
              </v-card>
            </div>
          </div>
        </v-col>
      </div>
    </div>
    <SkeletonLoader :loading="loading" />
    <app-dialog-box
      :open="dialog"
      :isPersistent="true"
      :title="deleteTitle"
      :content="$t('')"
      :main-action-label="$t('Yes')"
      @mainAction="deleteActivityOrTask()"
      :secondary-action-label="$t('No')"
      @secondaryAction="closeDialog"
    />
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import { activitiesTasksDataMixin } from "../../../../mixins/field/activitiesTasksDataMixin";
import { mixin as clickaway } from "vue-clickaway";
import SkeletonLoader from "./_Organisms/SkeletonLoader.vue";
import AppDialogBox from "../../../_Molecules/AppDialogBox";
export default {
  name: "WorkOrderDetailTemplates",

  mixins: [activitiesTasksDataMixin, clickaway],

  components: { AppDialogBox,SkeletonLoader },

  props: {
    receivedData: {
      type: Object
    },
    disabledView: {
      type: Boolean
    },

    actionType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      isDeleteActivity: false,
      currentActivity: {},
      currentTask: {},
      templates: [],
      selected: null,
      usedElements: false,
      menu: false,
      searchTemplate: null,
      selectedTemplates: [],
      data: [],
      loading: false,
      dataToSend: {
        text_geom: null,
        projection: null,
        activity: {
          uuid: null,
          filter: {}
        }
      }
    };
  },
  /**
   * when mounted gets activity templates
   */
  mounted() {
    this.getActivityTemplates();
  },
  computed: {
    /**
     * @returns - selected templates(unique)
     */
    selectedTemplatesFor() {
      return this.$store.state.workOrders.selectedTemplates;
    },
    deleteTitle(){
      const message = this.isDeleteActivity ? ` ${this.$tc('Activity', 1)} ${this.currentActivity.title} ?` : ` ${this.$tc('Task',1)} ${this.currentTask.title} ?`;
      return `${this.$t('Delete')}` + message;
    },
    /**
     * @returns - geom drawn from polygon
     */
    textGeom() {
      return this.$store.state.object.multiObjectSelection.polygon;
    },
    /**
     * @returns - used projection when drawing polygon
     */
    projection() {
      return this.$store.state.object.multiObjectSelection.projection;
    },
    /**
     * @returns - if there are already selected templates those are filtered from the list and sorted, if there aren't any selected all are sorted.
     *            if the user searchs for a template the sorted array gets filtered.
     */
    filterTemplates() {
      let filteredtemplates = [];
      let sorted;
      if (this.selectedTemplates.length > 0) {
        for (const template of this.templates) {
          if (
            !this.selectedTemplates.find(item => item.uuid === template.uuid)
          ) {
            filteredtemplates.push(template);
          }
        }
        sorted = filteredtemplates.sort((a, b) =>
          a.title.localeCompare(b.title)
        );

        return sorted.filter(item => {
          if (this.searchTemplate) {
            return item.title
              .toLowerCase()
              .includes(this.searchTemplate.toLowerCase());
          } else {
            return item;
          }
        });
      } else {
        sorted = this.templates.sort((a, b) => a.title.localeCompare(b.title));
        return sorted.filter(item => {
          if (this.searchTemplate) {
            return item.title
              .toLowerCase()
              .includes(this.searchTemplate.toLowerCase());
          } else {
            return item;
          }
        });
      }
    }
  },
  watch: {
    /**
     * when user selects a template a request is made with all necessary information to retreive the matching objects.
     */
    selected(value) {
      if (value) {
        this.dataToSend.activity.uuid = value.uuid;
        this.dataToSend.connectedElements = this.usedElements;
        this.dataToSend.text_geom = this.textGeom || this.receivedData.geom;
        this.dataToSend.projection = this.actionType === 'edit' ? 4326 : this.projection || "3857";
        this.dataTosend = Object.assign(
          this.dataToSend.activity.filter,
          value.object_type
        );
        this.dataToSend.activity.tasks = [];
        for (const task of value.tasks) {
          this.dataToSend.activity.tasks.push({
            uuid: task.uuid,
            filter: task.object_type
          });
        }

        this.sendTemplate(this.dataToSend);
      }
    }
  },

  methods: {
    ...mapActions([
      "fetchActivityTemplates",
      "sendTemplateData",
      "resetselectedTemplateState",
      "deleteTemplates",
      "deleteActivity",
      "deleteTask"
    ]),
    openActivityDialog(activity){
      this.currentActivity = activity;
      this.dialog = true;
      this.isDeleteActivity = true;
    },
    openTaskDialog(activity, task){
      this.currentActivity = activity;
      this.currentTask = task;
      this.dialog = true;
    },
    closeDialog(){
      this.dialog = false;
      this.isDeleteActivity = false;
    },
    deleteActivityOrTask(){
      if(this.isDeleteActivity){
        this.deleteActivityNow();
      }else{
        this.deleteTaskNow();
      }
    },
    /**
     * deletes all activities of that template and removes from the store the selected template.
     */
    deleteTemplate(template) {
      let activities = this.receivedData.activities;
      let filtered = activities.filter(item => template.title !== item.title);
      this.receivedData.activities = filtered;
      this.deleteTemplates(template);
    },
    /**
     * closes menu
     */
    closeSearch() {
      this.menu = false;
    },
    /**
     * when template is selected watcher is used and menu disappears
     */
    selectTemplate(template) {
      this.selected = template;
      this.menu = false;
    },
    /**
     * deletes activities, if activities are 0, clears data and vuex store
     */
    deleteActivityNow() {
      let index = this.receivedData.activities.indexOf(this.currentActivity);
      
      try{
        this.deleteActivity(this.currentActivity.uuid);
        this.receivedData.activities.splice(index, 1);
      } catch (err) {
        console.log(err);
      }
      if (this.receivedData.activities.length === 0) {
        this.resetselectedTemplateState();

        this.selectedTemplates = [];
      }
      this.isDeleteActivity = false;
      this.dialog = false;
    },
    /**
     * deletes tasks from activities, if all tasks are deleted the activity gets deleted, if user deletes all tasks and subsequently all activities
     * the selectedtemplate gets reseted .
     */
    deleteTaskNow() {
      const activity = {...this.currentActivity};
      const task = {...this.currentTask};
      let index = activity.tasks.findIndex(item => item.title === task.title);
      activity.tasks.splice(index, 1);
      try{
        this.deleteTask({activityUUID: activity.uuid,
          taskUUID: task.uuid});
      } catch (err) {
        console.log(err);
      }
      if (this.receivedData.activities.length === 0) {
        this.resetselectedTemplateState();

        this.selectedTemplates = [];
      }
      this.isDeleteActivity = false;
      this.dialog = false;
    },
    checkActivityOrTaskState(state){
      return (state === 'created' || state === 'assigned' || state === 'scheduled');
    },
    /**
     * @returns - activity templates
     */
    async getActivityTemplates() {
      try {
        this.templates = await this.fetchActivityTemplates();
      } catch (err) {
        console.error(err);
      } finally {
      }
    },
    /**
     * When the data is received the activities are filled with the task and activities templates values
     * Back end sends, an activity with the tasks that are usable.
     */
    async sendTemplate(data) {
      try {
        this.loading = true;
        let dataReceived = await this.sendTemplateData(data);
        if (dataReceived.length === 0) {
          this.$toasted.global.toast_error(this.$i18n.tc("NoNewObjects"));

          return;
        } else {
          this.selectedTemplates.push(this.selected);
          let datas = dataReceived.map(element => {
            element.description = this.selected.description;
            element.object_uuid = element.uuid;
            element.object_type = element.layer;
            element.title = this.selected.title;
            element.company = [];
            delete element.uuid;
            delete element.layer;
            let arr = [];

            for (const task of this.selected.tasks) {
              if (element.tasks.includes(task.uuid)) {
                let tasks = {
                  user_assignee_id: null,
                  company_id: null,
                  scheduled_date: null,
                  content: task.content,
                  cost: task.cost,
                  execution_time: task.execution_time,
                  title: task.title,
                  type: task.type,
                  auto_approval: task.auto_approval
                };
                arr.push(tasks);
              }
            }
            element.tasks = arr;
            return element;
          });

          this.data = datas;

          this.$emit("objectTemplates", this.data);
          this.$store.commit("selectedTemplates", this.selectedTemplates);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.selected = null;
        this.loading = false;
      }
    }
  }
};
</script>
<style scoped>
.left-side {
  border-left: 1px solid #666666;

  height: 100%;
}
.rotate-text {
  writing-mode: vertical-rl;
  text-orientation: sideways-right;
  transform: rotate(180deg);
  padding-top: 10px;
  text-align: left;
  font: normal normal normal 14px Roboto;
  letter-spacing: 0.11px;
  color: #666666;
  opacity: 1;
}
.rotate-button {
  transform: rotate(270deg);
  margin-bottom: 5px;
}
.menu {
  width: 184px !important;
  height: 32px;
  z-index: 1 !important;
  cursor: pointer;
}

.v-text-field.v-text-field--solo.v-input--dense >>> .v-input__control {
  min-height: 32px !important;
}
.v-text-field.v-text-field--solo.v-input--dense >>> .v-input__slot {
  background: #e0e0e0;
  text-align: left;
  font: normal normal normal 12px/16px Roboto;
  letter-spacing: 0.14px;
  color: #666666;
  opacity: 1;
}
.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  >>> .v-input__slot {
  box-shadow: none !important;
}
.v-autocomplete__content.v-menu__content .v-select-list {
  width: 261px;
  text-align: left;
}

.v-autocomplete__content.v-menu__content
  .v-select-list
  >>> .v-list-item__title {
  font-size: 18px;
  font-family: Roboto;
  font-weight: normal;
}

.task-text {
  text-align: left;
  font: normal normal normal 10px/24px Roboto;
  letter-spacing: 0.08px;
  color: #666666;
  opacity: 1;
  padding-left: 10px;
  padding-top: 5px;
}
.card-title {
  position: absolute;
  transform: translateY(-45px) translateX(10px);
  z-index: 1000;
  font: normal normal normal 12px Roboto;
  letter-spacing: 0.1px;
  color: #666666;
  opacity: 1;
  text-align: left;
  padding-left: 5px;
  padding-top: 2px;
}
.v-input >>> .v-text-field__details {
  min-height: 0px;
}
.v-input >>> .theme--light.v-label {
  color: rgba(128, 128, 128, 0.685);
}

.activity-delete-button {
  position: absolute;
  right: 0px;
  top: 0px;
}

.menu-position-templates {
  position: absolute;

  top: 210px;
  width: 184px;
  z-index: -1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 4px;
  opacity: 1;
}
ul {
  line-height: normal;
  padding: 14px 0px 0px 0px;
  list-style: none;

  text-align: left;
}
li:hover {
  background-color: #e0e0e034;
}
li {
  padding: 5px 0px 5px 10px;
  cursor: pointer;
  text-align: left;
  font: normal normal normal 14px/18px Roboto;
  letter-spacing: 0.11px;
  color: #666666;
  opacity: 1;
}
.v-text-field >>> input {
  cursor: pointer;
}
.v-text-field >>> .v-input__icon {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/WorkOrderForm/WorkOrderDetailTemplates.vue